// I18N_START
const TRANSLATIONS = {
  en: {
    lose: "Game Over",
    tap_to_play: "Tap to play again",
    win: "You Win!",
    resume: "Resume",
    restart_game: "Restart",
    to_hub: "Home",
    hook_2048_nearwin: "One move from 2048!",
    hook_2048_almost: "Finish it — reach 2048",
    hook_2048_midgame: "Pick up where it's hot",
    hook_play: "Play",
    cta_win_title: "You win! 🎉",
    cta_install: "Add to home screen",
    cta_again: "Play again",
  },
  hi: {
    lose: "खेल खत्म",
    tap_to_play: "फिर से खेलने के लिए टैप करें",
    win: "आप जीते!",
    resume: "जारी रखें",
    restart_game: "फिर से",
    to_hub: "मुख्य",
    hook_2048_nearwin: "2048 से बस एक चाल दूर!",
    hook_2048_almost: "पूरा करें — 2048 तक पहुँचें",
    hook_2048_midgame: "जहाँ मज़ा है वहीं से खेलें",
    hook_play: "खेलें",
    cta_win_title: "आप जीते! 🎉",
    cta_install: "होम स्क्रीन पर जोड़ें",
    cta_again: "फिर से खेलें",
  },
  ru: {
    lose: "Проигрыш",
    tap_to_play: "Нажмите, чтобы играть снова",
    win: "Победа!",
    resume: "Продолжить",
    restart_game: "Заново",
    to_hub: "В хаб",
    hook_2048_nearwin: "Один ход до 2048!",
    hook_2048_almost: "Дожми до 2048",
    hook_2048_midgame: "Продолжи партию",
    hook_play: "Играть",
    cta_win_title: "Победа! 🎉",
    cta_install: "Добавить на экран",
    cta_again: "Ещё разок",
  },
} as const;
// I18N_END

type Lang = keyof typeof TRANSLATIONS;
type Key  = keyof typeof TRANSLATIONS['ru'];
type Params = Record<string, string | number>;

const _lang = (localStorage.getItem('lang') ?? navigator.language.slice(0, 2)) as Lang;
const _L    = TRANSLATIONS[_lang in TRANSLATIONS ? _lang : 'ru'];

export function t(key: Key, params?: Params): string {
  let s: string = _L[key] ?? TRANSLATIONS['ru'][key];
  if (params) for (const k in params) s = s.replace(`{${k}}`, String(params[k]));
  return s;
}
